/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable multiline-ternary */
import { useQuery } from '@apollo/client'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { FETCH_PROCEDURES } from '../../graphql/queries'
import theme from '../../theme'
import { SuccessButton } from '../Buttons'
import ProcedureCard from '../Config/Procedures/ProcedureCard'
import { ProcedureItem } from '../Config/Procedures/types'
import { Procedure } from './types'

interface PacientDialogProps {
  handleChange: (procedure: ProcedureItem) => void
  handleClose: () => void
  initialValue?: ProcedureItem
}

const AmountCustomInput = (props: any) => <TextField label="Preço" {...props} />

enum Mode {
  CREATE = 'CREATE',
  LIST = 'LIST'
}
const OrderItemDialogComponent = ({
  handleChange,
  handleClose,
  initialValue
}: PacientDialogProps): JSX.Element | null => {
  const [mode, setMode] = useState<Mode>(Mode.CREATE)
  const {
    control,
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<ProcedureItem>({
    defaultValues: initialValue || {
      price: {
        float: 0
      }
    },
    mode: 'onChange',
    shouldUnregister: true,
    shouldFocusError: true
  })
  const { data: proceduresData } = useQuery(FETCH_PROCEDURES)
  const procedures = proceduresData?.procedures?.edges as Procedure[]

  const onSubmit = (item: ProcedureItem) => {
    handleChange(item)
    handleClose()
  }
  return (
    <div>
      <Dialog open onClose={handleClose} fullWidth>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Adicionar itens</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Selecione um procedimento ou adicione um item novo.
            </DialogContentText>
            <div style={{ marginBottom: 15 }}>
              <Button
                variant={mode === Mode.CREATE ? 'contained' : 'outlined'}
                color="primary"
                onClick={() => setMode(Mode.CREATE)}
                type="button"
                style={{ marginRight: 15 }}
              >
                Criar
              </Button>
              <Button
                variant={mode === Mode.LIST ? 'contained' : 'outlined'}
                color="primary"
                onClick={() => setMode(Mode.LIST)}
                type="button"
              >
                Buscar da lista
              </Button>
            </div>
            {mode === Mode.CREATE ? (
              <>
                <Controller
                  name="code"
                  control={control}
                  rules={{
                    pattern: {
                      value: /[0-9]/i,
                      message: 'Apenas valores númericos'
                    },
                    required: 'Este campo é obrigatório'
                  }}
                  render={({ onChange, value }) => (
                    <TextField
                      label="Código"
                      autoFocus
                      fullWidth
                      inputProps={{ ...register() }}
                      value={value || ''}
                      onChange={onChange}
                      margin="dense"
                      helperText={errors.code?.message}
                      error={!!errors.code?.message}
                    />
                  )}
                />
                <br />
                <Controller
                  name="name"
                  control={control}
                  rules={{
                    required: 'Este campo é obrigatório'
                  }}
                  render={({ onChange, value }) => (
                    <TextField
                      label="Nome"
                      fullWidth
                      value={value || ''}
                      onChange={onChange}
                      margin="dense"
                      helperText={errors.name?.message}
                      error={!!errors.name?.message}
                    />
                  )}
                />
                <br />
                <Controller
                  name="price.float"
                  control={control}
                  render={({ onChange, value }) => (
                    <NumberFormat
                      style={{ width: '100%' }}
                      prefix="R$ "
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale
                      value={value}
                      onValueChange={values => onChange(values.floatValue)}
                      allowNegative={false}
                      allowedDecimalSeparators={['.', ',']}
                      customInput={AmountCustomInput}
                    />
                  )}
                />
              </>
            ) : (
              <>
                {procedures.map((procedure, index) => (
                  <React.Fragment key={index}>
                    <ProcedureCard
                      procedure={procedure}
                      handleSelect={procedure => {
                        procedure.items.map(p =>
                          handleChange({ ...p, ref: procedure.id })
                        )
                        handleClose()
                      }}
                      style={{ background: theme.palette.primary.light }}
                    />
                    <br />
                  </React.Fragment>
                ))}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <SuccessButton type="submit" color="primary">
              Adicionar Item
            </SuccessButton>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}

export const OrderItemDialog = React.memo(OrderItemDialogComponent)
